<section class="sfe-safe sfe-welcome">
  <div>
    <h1 class="sfe-welcome-head">
      Related Businesses
      <!-- {{ user?.displayName?.replace("Admin", "Super Admin") || "Super Admin" }} -->
    </h1>
    <p>Here are the businesses that currently have, or have had, your admin code. You can revoke users admin codes here, you will still be able to view their assessment results.</p>
    <div>
      <button
        *ngIf="isSuperAdmin"
        class="sfe-capitalize sfe-button-round sfe-button-blue"
        mat-raised-button
        [routerLink]="['/super-admin', 'dashboard']"
      >
        Admin List
      </button>
    </div>
  </div>
</section>
<div class="pt-5"></div>

<section class="card">
<ng-container *ngIf="dataSource?.data?.length; else noResult">
  <div class="pt-3 pl-3">
    <h2 class="h2">List of all Businesses</h2>
  </div>
  <table mat-table [dataSource]="dataSource">
    <!-- Position Column -->
    <ng-container [matColumnDef]="displayedColumns[0]">
      <th mat-header-cell *matHeaderCellDef>{{ displayedColumns[0] }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element?.companyName || "" }}
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container [matColumnDef]="displayedColumns[1]">
      <th mat-header-cell *matHeaderCellDef>{{ displayedColumns[1] }}</th>
      <td mat-cell *matCellDef="let element">
        {{
          element?.firstName ||
            (element?.displayName?.length &&
              element?.displayName?.split(" ")[0]) ||
            ""
        }}
      </td>
    </ng-container>

    <ng-container [matColumnDef]="displayedColumns[2]">
      <th mat-header-cell *matHeaderCellDef>{{ displayedColumns[2] }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element?.lastName || "" }}
      </td>
    </ng-container>

    <ng-container [matColumnDef]="displayedColumns[3]">
      <th mat-header-cell *matHeaderCellDef>{{ displayedColumns[3] }}</th>
      <td mat-cell *matCellDef="let element">
        {{
          element?.adminCode?.timestampedcreation
            | date: "medium":adminCode?.timezone
        }}
      </td>
    </ng-container>

    <ng-container [matColumnDef]="displayedColumns[4]">
      <th mat-header-cell *matHeaderCellDef>{{ displayedColumns[4] }}</th>
      <td mat-cell *matCellDef="let element">
        {{
          element?.adminCode?.timestampedremove
            | date: "medium":adminCode?.timezone
        }}
      </td>
    </ng-container>

    <ng-container [matColumnDef]="displayedColumns[5]">
      <th mat-header-cell *matHeaderCellDef>{{ displayedColumns[5] }}</th>
      <td mat-cell *matCellDef="let element">
        <p
          class="hasAdminCode"
          [title]="
            element?.adminCode && !element?.adminCode?.disabled
              ? 'Active'
              : 'Disabled'
          "
        >
          <mat-icon
            [color]="
              element?.adminCode && !element?.adminCode?.disabled
                ? 'primary'
                : 'warn'
            "
            >{{
              element?.adminCode && !element?.adminCode?.disabled
                ? "check_circle"
                : "cancel"
            }}</mat-icon
          >
        </p>
      </td>
    </ng-container>

    <ng-container [matColumnDef]="displayedColumns[6]">
      <th mat-header-cell *matHeaderCellDef>{{ displayedColumns[6] }}</th>
      <td mat-cell *matCellDef="let element">
        <button
          [disabled]="
            !element?.adminCode ||
            (!isString(element?.adminCode) && !element?.adminCode?.value) ||
            element?.adminCode?.disabled
          "
          class="sfe-capitalize sfe-button-round sfe-button-blue more-btn"
          mat-raised-button
          (click)="
            (element?.adminCode?.value || element?.adminCode) &&
              revokeAdminCode(element?.adminCode, element?.uid)
          "
        >
          {{ !element?.adminCode?.disabled ? "Revoke code" : "Code revoked" }}
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-paginator
    [pageSizeOptions]="[5, 10, 20]"
    showFirstLastButtons
    aria-label="Select page of admin users"
  >
  </mat-paginator>
</ng-container>
</section>
<ng-template #noResult>
  <div class="no-result">No Businesses associated.</div>
</ng-template>
